import { createSlice} from "@reduxjs/toolkit";
const getAllComplianceslice = createSlice({
  name: 'getAllComplianceData',
      initialState:{
        data:null,
        loading:false,
        error:null,
  },
  reducers: {
    fetchData: (state) => {
      state.loading = true;
    },
    fetchDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    reSetData:()=>{
      return []
    }
  },
});
export const { fetchData, fetchDataSuccess, fetchDataError,reSetData } = getAllComplianceslice.actions;
export default getAllComplianceslice.reducer;